import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

function OpalHeading ({ level, children, className, style }) {
  return (
    <div className={clsx(className, `opal-heading opal-heading-${level}`)} style={style}>
      {children}
    </div>
  )
}

OpalHeading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  level: PropTypes.oneOf([1, 2, 3, 4, 5])
}

OpalHeading.defaultProps = {
  level: 1
}

export default OpalHeading
